import { useContext } from 'react';
import WelcomeSlidesContext, { IWelcomeSlidesContext } from 'Contexts/WelcomeSlidesContext';

const useWelcomeSlides = (): IWelcomeSlidesContext => useContext(WelcomeSlidesContext);

export default useWelcomeSlides;
